module.exports = __webpack_public_path__ + "img/curved20.6ce03df3.jpeg";